import React from 'react'
import Modal from 'meinian-package/src/baseComponent/modal'
import Button from 'meinian-package/src/baseComponent/button'
import styles from './index.module.less'

export default ({ onGo, visible, onClose }) => {
  return <Modal
    visible={!!visible}
    style={{ width: 800, height: 482 }}
    hiddenCloseIcon={false}
    hiddenFooter
    onClose={() => {
      onClose()
    }}
  >
    <ModalContent onClose={onClose} onGo={onGo} />
  </Modal>
}

const ModalContent = ({ onClose, onGo }) => {
  return <div className={styles.cooperationTipModal}>
    <div className={styles.cooperationTipModalTitle}>灵感集如何添加同事协作</div>
    <div className={styles.cooperationTipModalContent}>
      <div className={styles.cooperationTipModalContentLeft}>
        <div className={styles.cooperationTipModalContentTitle}>1. 点击右上角的“协作成员”</div>
        <img className={styles.cooperationTipModalContentImage} src="https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/meinian-image/cooperationMember.png" />
      </div>
      <div className={styles.cooperationTipModalContentRight}>
        <div className={styles.cooperationTipModalContentTitle}>2. 点击左边成员的“+”按钮，即可添加</div>
        <img className={styles.cooperationTipModalContentImage} src="https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/meinian-image/addMember.png" />
      </div>
    </div>
    <div className={styles.cooperationTipModalFooter}>
      <Button
        style={{ width: '128px', marginRight: '16px' }}
        onClick={() => {
          onGo()
          onClose()
        }}
      >去试试</Button>
      <Button style={{ width: '128px' }} type="primary" onClick={() => onClose()}>我知道了</Button>
    </div>
  </div>
}
